const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const popupApi = {
  // Get all popups with pagination and filtering
  getPopups: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const response = await fetch(`${BASE_URL}/api/popups?${query}`);
    return response.json();
  },

  // Get active popups for frontend display
  getActivePopups: async () => {
    const response = await fetch(`${BASE_URL}/api/popups/active`);
    return response.json();
  },

  // Get a single popup by ID
  getPopup: async (id) => {
    const response = await fetch(`${BASE_URL}/api/popups/${id}`);
    return response.json();
  },

  // Create a new popup with file upload support
  createPopup: async (formData) => {
    const response = await fetch(`${BASE_URL}/api/popups`, {
      method: 'POST',
      // Don't set Content-Type header - let the browser set it with the correct boundary
      body: formData,
    });
    return response.json();
  },

  // Update a popup with file upload support
  updatePopup: async (id, formData) => {
    const response = await fetch(`${BASE_URL}/api/popups/${id}`, {
      method: 'PUT',
      // Don't set Content-Type header - let the browser set it with the correct boundary
      body: formData,
    });
    return response.json();
  },

  // Delete a popup
  deletePopup: async (id) => {
    const response = await fetch(`${BASE_URL}/api/popups/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },

  // Toggle popup enabled status
  togglePopup: async (id) => {
    const response = await fetch(`${BASE_URL}/api/popups/${id}/toggle`, {
      method: 'PATCH',
    });
    return response.json();
  }
};

export default popupApi;
